import React, {Component} from "react"
import {Modal, SearchBar, Toast} from 'antd-mobile';
import "./style.less";
import {city2,city3} from "../../config/city"
let curList = [];
let listDom = [];
let cityData = city3;
export default class NationalCity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cityData:[],
            // onFocus:false,
            flag:[],
            provinceFlag:false,
            citySearch:'',
        };
    }

    componentDidMount  () {}
    onScrollHandle(res,i) {
        this.tabDOM.scrollTop = listDom[i].offsetTop - (document.documentElement.clientWidth / 750 * 188);
    }
    listDOM(instance) {
        if (instance) {
            listDom.push(instance)
        }
    }
    searchChange=(v)=>{
        this.setState({citySearch:v});
        //搜索
        // if(v !== ''){
        //     for (let k in city2){
        //         for(let n in city2[k].citys){
        //             cityData = [];
        //             if(city2[k].citys[n].indexOf(v) !== -1){
        //                 cityData.push(city2[k]);
        //                 return
        //             }
        //         }
        //     }
        // }else{
        //     cityData = city2;
        // }
        if(v !== ''){
            cityData = [];
            city3.map((res)=>{
                if(res.fullname.indexOf(v) !== -1){
                    cityData.push(res);
                    return
                }
            })
        }else{
            cityData = city3;
        }
    };
    render() {
        if(this.props.modal === false){
            listDom=[];
        }
        curList = [];
        for (let k in this.props.data) {
            curList.push({
                key: k,
                arr: this.props.data[k],
            });
        }
        return (
            <Modal
                className="nationalCityModal"
                visible={this.props.modal}
                onClose={() => this.props.onClose()}
                maskClosable={false}
            >
                <div className="modalTopBar">
                    <i className="icon iconfont iconfanhui" onClick={() => this.props.onClose()} />
                    <div className="endTitle" >选择城市</div>
                </div>
                <SearchBar
                    className="searchBar"
                    value={this.state.citySearch}
                    placeholder={'搜索城市'}
                    onChange={this.searchChange}
                    showCancelButton={false}
                />
                <div className='content' ref={dom => {this.tabDOM = dom}}>
                    <div className="cityList" >
                        {
                            cityData && cityData.map((res,i)=>(
                                <div className="listgroup" key={i} ref={this.listDOM}  >
                                    {/* <div className="title J_scroll_title">{res.name}</div>
                                    <div  className="cityDiv">
                                        {res.citys.map((n,index)=>(
                                            <div key={index} className="cityItem" onClick={() => this.props.runChange(n)}>{n}</div>
                                        ))}
                                    </div> */}
                                    <div  className="cityDiv">
                                        <div key={i} className="cityItem" onClick={() => this.props.runChange(res)}>{res.fullname}</div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {/*<div className="city_anchor">
                    {
                        cityData.map((res, i) => {
                            return (
                                <a key={i} onClick={() => this.onScrollHandle(res,i)}>
                                    {res.name}
                                </a>
                            )
                        })
                    }
                </div>*/}
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NationalCity/index.js